<cipo-dialog-header
    [title]="'MODULE_DEF_ADDRESS.GLOBAL_DIALOG_TITLE'"
    testId="cipo-global-addresses-dialog-title"
    closeTestId="cipo-global-addresses-dialog-close" />
<mat-dialog-content class="global-addresses-dialog-content">
    <div fxLayout fxLayoutGap="8px" class="cipo--height--full">
        <!-- left column: address list + search -->
        <div fxFlex="250px" fxLayout="column" class="cipo--height--full">
            <div fxFlex="74px">
                @if (canCreateGlobalAddress()) {
                    <button
                        mat-raised-button
                        color="primary"
                        data-testid="cipo-global-addresses-dialog-add"
                        [disabled]="addresses().length > 0 && !currentAddressIsValid()"
                        (click)="addAddress()">
                        <mat-icon aria-hidden="true">add</mat-icon>
                        {{ "actions.addNew" | translate }}
                    </button>
                }
            </div>
            <mat-form-field class="cipo--width--full" appearance="outline">
                <mat-icon matPrefix>search</mat-icon>
                <input
                    matInput
                    [ngModel]="searchTerm()"
                    (ngModelChange)="searchTerm.set($event)"
                    [placeholder]="'MODULE_DEF_ADDRESS.SEARCH_GLOBAL_PLACEHOLDER' | translate"
                    data-testid="cipo-global-addresses-dialog-search" />
                @if (searchTerm()) {
                    <button
                        matSuffix
                        mat-icon-button
                        (click)="searchTerm.set('')"
                        [attr.aria-label]="'a11y.form.clearInput' | translate">
                        <mat-icon aria-hidden="true">close</mat-icon>
                    </button>
                }
            </mat-form-field>
            <div fxFlex class="cipo--overflow--auto">
                <mat-list role="list" data-testid="cipo-global-addresses-dialog-list">
                    @for (addr of filteredAddresses(); track addr.locationId ?? $index) {
                        @if (!$first) {
                            <mat-divider></mat-divider>
                        }
                        <mat-list-item
                            role="listitem"
                            class="selectable cipo--height--auto-important p-a-xs"
                            data-testid="cipo-global-addresses-dialog-list-item"
                            [class.selected]="addresses().indexOf(addr) === addressIndex()"
                            [class.disabled]="addresses().indexOf(addr) !== addressIndex() && !currentAddressIsValid()"
                            (click)="setAddress($index)">
                            <div fxLayout fxLayoutGap="8px" fxLayoutAlign="start center" class="address">
                                <div
                                    fxFlex="none"
                                    [innerHTML]="
                                        azureMapService.createPinElement(
                                            addresses().indexOf(addr),
                                            addresses().indexOf(addr) === addressIndex(),
                                            true
                                        )
                                    "></div>
                                <div fxFlex>
                                    @if (addr.address && addr.lat && addr.lon) {
                                        <div class="cipo-text--medium-sm">
                                            {{ addressService.formatAddress(addr, displayType) }}
                                        </div>
                                        <div class="cipo-text--label">
                                            {{ addressService.formatPosition(addr) }}
                                        </div>
                                    } @else {
                                        <div class="cipo-text--label">
                                            {{ "MODULE_DEF_ADDRESS.NO_ADDRESS" | translate }}
                                        </div>
                                    }
                                </div>
                                @if (canDeleteGlobalAddress()) {
                                    <button
                                        fxFlex="none"
                                        mat-icon-button
                                        class="cipo--display--none delete-action"
                                        data-testid="cipo-global-addresses-dialog-delete"
                                        [attr.aria-label]="'a11y.common.delete' | translate"
                                        (click)="$event.stopPropagation(); deleteAddress($index)">
                                        <mat-icon class="m-t-xs" aria-hidden="true">delete</mat-icon>
                                    </button>
                                }
                            </div>
                        </mat-list-item>
                    }
                    @if (addresses().length === 0) {
                        <cipo-not-found [title]="'MODULE_DEF_ADDRESS.NO_GLOBAL_ADDRESSES' | translate" />
                    } @else if (filteredAddresses().length === 0) {
                        <cipo-not-found [title]="'MODULE_DEF_ADDRESS.NO_SUGGESTIONS' | translate" />
                    }
                </mat-list>
            </div>
        </div>
        <!-- right column: form + map -->
        <div fxFlex fxLayout="column" class="cipo--height--full">
            @if (addresses().length > 0) {
                <cipo-address-form
                    fxFlex="74px"
                    [editMode]="canCreateGlobalAddress() || canUpdateGlobalAddress()"
                    [multiple]="true"
                    [index]="addressIndex()"
                    [address]="address()"
                    (addressChange)="addressChanged($event)"></cipo-address-form>
            }
            <cipo-azure-map
                fxFlex
                [editMode]="addresses().length > 0 && canEditCurrentAddress()"
                [multiple]="true"
                [coordinates]="coordinates()"
                (coordinatesChange)="handleCoordinatesChanged($event)"
                [(selected)]="addressIndex"></cipo-azure-map>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ "general.close" | translate }}</button>
    <button
        mat-flat-button
        color="primary"
        data-testid="cipo-global-addresses-dialog-save"
        [disabled]="!isValid() || !changed()"
        (click)="save()">
        {{ "general.save" | translate }}
    </button>
</mat-dialog-actions>
